import {createReducer} from '@reduxjs/toolkit'
import {handleFormViewState, setBaseEnvironment, setFormFactor} from '../actions/environment'
import {EnvironmentConfig} from '../types/state'

const defaultState: EnvironmentConfig = {
  formViewState: false,
} as EnvironmentConfig

export const environment = createReducer(defaultState, builder => {
  builder
    .addCase(setBaseEnvironment.fulfilled, (state, action) => {
      return {...state, ...action.payload}
    })
    .addCase(setFormFactor, (state, action) => {
      return {...state, mobile: action.payload}
    })
    .addCase(handleFormViewState.fulfilled, (state, action) => {
      return {...state, formViewState: action.payload}
    })
})
